<script lang="ts">
    import inputfields from "./"

    export let ftpAssetsUrl: string

    // Choices from MailboxFilter
    export let currentChoices = null

    export let value: {
        [key: string]: any
    }[] = []
    export let label: string
    export let subFields: []
    export let values: { [key: string]: any }
    values = values || null
</script>

<div class="object-array">
    {#if label}
        <label for="">{label}</label>
    {/if}
    {#each subFields || [] as field}
        <svelte:component
            this="{inputfields[field.widget || field.type] || inputfields.default}"
            {...field}
            {values}
            bind:value="{value[field.name]}"
            {currentChoices}
            on:invalid-config
            {ftpAssetsUrl}
        />
    {/each}
</div>
